export class PagoCliente {
  constructor(data = {}) {
    // Normalizar las claves de entrada (mayúsculas y minúsculas)
    const normalizedData = this.normalizeKeys(data);
    
    this.Id_pagoc = normalizedData.id_pagoc || normalizedData.Id_pagoc || '';    
    this.Descripcion = normalizedData.descripcion || normalizedData.Descripcion || '';    
    this.Imagen = normalizedData.imagen || normalizedData.Imagen || '';
    this.ImagenFile = normalizedData.imagenFile || normalizedData.ImagenFile || null;
    this.Estado = normalizedData.estado || normalizedData.Estado || 'ACTIVO';    
    this.Id_sucursal = normalizedData.id_sucursal || normalizedData.Id_sucursal || '';    
    this.Nombre_sucursal = normalizedData.nombre_sucursal || normalizedData.Nombre_sucursal || '';    
    this.Fecha = normalizedData.fecha || normalizedData.Fecha || '';
    this.Hora = normalizedData.hora || normalizedData.Hora || '';
  }

  normalizeKeys(data) {
    if (!data) return {};
    
    const normalized = {};
    for (const [key, value] of Object.entries(data)) {
      normalized[key.toLowerCase()] = value;
      normalized[key] = value; // Mantener original también
    }
    return normalized;
  }

  // Para mostrar en consola (debug)
  toDebug() {
    return {
      Id_pagoc: this.Id_pagoc,      
      Descripcion: this.Descripcion,      
      Imagen: this.Imagen ? `[${this.Imagen.length} caracteres]` : 'Sin imagen',
      ImagenFile: this.ImagenFile ? 'Archivo presente' : 'Sin archivo',
      Estado: this.Estado,      
      Id_sucursal: this.Id_sucursal,      
      '🔍 PARA_API': {
        imagenFile: this.ImagenFile ? 'Se enviará como FormData' : 'NULL',
        imagen: 'NO se envía al API (solo se usa para preview)'
      }
    };
  }

  // ❌ MÉTODO REMOVIDO - NO USAR PARA C# API
  // Este método enviaba datos JSON, pero C# espera FormData
  // El ProductoService ahora maneja la creación del FormData directamente
  
  // ❌ MÉTODO REMOVIDO - NO USAR PARA C# API  
  // Este método enviaba datos JSON, pero C# espera FormData
  // El ProductoService ahora maneja la creación del FormData directamente

  // ✅ MÉTODO PARA VALIDAR DATOS ANTES DEL ENVÍO
  isValid() {
    return !!(
      this.Id_sucursal
    );
  }

  // ✅ MÉTODO PARA OBTENER DATOS BÁSICOS (sin imagen)
  getBasicData() {
    return {
      id_pagoc: this.Id_pagoc,
      descripcion: this.Descripcion,
      estado: this.Estado,     
      id_sucursal: parseInt(this.Id_sucursal) || null,      
      nombre_sucursal: this.Nombre_sucursal
    };
  }

  // ✅ MÉTODO MEJORADO - GENERAR URL DE IMAGEN DESDE BASE64
  getImageUrl() {
    if (!this.Imagen) return null;
    
    // Si ya es una URL, devolverla directamente
    if (this.Imagen.startsWith('data:') || this.Imagen.startsWith('http')) {
      return this.Imagen;
    }
    
    // Asumir que es base64 y crear data URL
    return `data:image/jpeg;base64,${this.Imagen}`;
  }

  // ✅ MÉTODO MEJORADO - ESTABLECER IMAGEN DESDE ARCHIVO
  setImageFromFile(file) {
    return new Promise((resolve, reject) => {
      if (!file) {
        this.ImagenFile = null;
        this.Imagen = '';
        resolve();
        return;
      }

      // Validar que sea un archivo de imagen
      if (!file.type.startsWith('image/')) {
        reject(new Error('El archivo debe ser una imagen'));
        return;
      }

      // Validar tamaño (máximo 5MB)
      if (file.size > 5 * 1024 * 1024) {
        reject(new Error('La imagen no debe superar los 5MB'));
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const result = e.target.result;
          const base64 = result.split(',')[1]; // Remover el prefijo data:image/...;base64,
          
          this.Imagen = base64;
          this.ImagenFile = file;
          
          console.log('✅ Imagen procesada correctamente:');
          console.log('  - Archivo:', file.name, file.size, 'bytes');
          console.log('  - Base64 length:', base64.length);
          console.log('  - ImagenFile establecido:', !!this.ImagenFile);
          
          resolve(base64);
        } catch (error) {
          console.error('❌ Error procesando imagen:', error);
          reject(error);
        }
      };
      
      reader.onerror = (error) => {
        console.error('❌ Error leyendo archivo:', error);
        reject(new Error('Error al leer el archivo'));
      };
      
      reader.readAsDataURL(file);
    });
  }

  // ✅ MÉTODO PARA LIMPIAR IMAGEN
  clearImage() {
    this.Imagen = '';
    this.ImagenFile = null;
  }

  // ✅ MÉTODO PARA VERIFICAR SI TIENE IMAGEN
  hasImage() {
    return !!(this.Imagen && this.Imagen.length > 0);
  }

  // ✅ MÉTODO PARA OBTENER TAMAÑO DE IMAGEN EN MB
  getImageSizeInMB() {
    if (!this.Imagen) return 0;
    
    try {
      const base64Data = this.Imagen.replace(/^data:image\/[^;]+;base64,/, '');
      const decoded = atob(base64Data);
      return (decoded.length / (1024 * 1024)).toFixed(2);
    } catch (error) {
      console.error('Error calculando tamaño de imagen:', error);
      return 0;
    }
  }

  // ✅ MÉTODO PARA CLONAR EL PRODUCTO
  clone() {
    return new PagoCliente({
      Id_pagoc: this.Id_pagoc,      
      Descripcion: this.Descripcion,      
      Imagen: this.Imagen,
      ImagenFile: this.ImagenFile,
      Estado: this.Estado,      
      Id_sucursal: this.Id_sucursal,      
      Nombre_sucursal: this.Nombre_sucursal,      
      Fecha: this.Fecha,
      Hora: this.Hora
    });
  }

  // ✅ MÉTODO PARA ACTUALIZAR DATOS (útil para ediciones)
  updateData(newData) {
    const updatedProduct = new PagoCliente(newData);
    
    // Preservar la imagen actual si no se proporciona nueva imagen
    if (!updatedProduct.Imagen && this.Imagen) {
      updatedProduct.Imagen = this.Imagen;
      updatedProduct.ImagenFile = this.ImagenFile;
    }
    
    return updatedProduct;
  }
}